import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterDataSearchDynamic } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterBadgeContent } from '@/app/common/filters/surfaces/badges/FilterBadgeContent.tsx';
import React from 'react';

export const FilterSearchDynamicBadge = ({ filter, isLoading, handleFilterChanged }: FilterComponentProps) => {
  const filterData = filter.data as FilterDataSearchDynamic;
  const { value } = filterData;

  const handleFilterClicked = () => {
    const updatedFilter = {
      ...filter,
      data: {
        ...filter.data,
        value: '',
      } as FilterDataSearchDynamic,
    };
    handleFilterChanged([updatedFilter]);
  };

  return <FilterBadgeContent label={value} handleFilterClicked={handleFilterClicked} isLoading={isLoading} />;
};
